import type { Skill } from "@cohesive/api-client";

/**
 * Skills available to mention in the picker: both Auto (enabled) and Manual
 * (disabled) skills are pickable — Manual skills are simply not auto-injected.
 * Archived (trashed) skills never reach the picker because the skill list
 * endpoint already excludes them.
 */
export function filterSkillsForPicker(skills: Skill[]): Skill[] {
  return skills.filter((skill) => !skill.archived_at);
}
